import { Button, Form, Input, Modal } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { PF } from '@app/pages/Warehouses/Brands/components/AddEditBrand/data';
import {
  useAddEditBrand,
  useAddEditBrandEffects,
} from '@app/pages/Warehouses/Brands/components/AddEditBrand/hooks';
import type {
  AddEditBrandForm,
  AddEditBrandType,
} from '@app/pages/Warehouses/Brands/components/AddEditBrand/types';

import '@pages/Warehouses/Brands/components/AddEditBrand/styles/AddEditBrand.scss';

const { Item } = Form;
const { TextArea } = Input;

export const AddEditBrand: AddEditBrandType = ({ mode = 'add' }) => {
  const {
    form,
    onFinish,
    openDeleteModal,
    closeDeleteModal,
    onDelete,
    isDeleteOpen,
    onCancel,
    disabledForm,
    initForm,
    skipForm,
    IsBrandDelete,
    isPageForbidden,
  } = useAddEditBrand({ mode });

  useAddEditBrandEffects({ initForm, skipForm });

  if (isPageForbidden) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <>
      <div className={`${PF}_container`}>
        <Form<AddEditBrandForm>
          form={form}
          layout="horizontal"
          labelAlign="left"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 10 }}
          className={`${PF}_form`}
          name={`${PF}_form`}
          initialValues={{ Name: '', Comment: '' }}
          onFinish={onFinish}
        >
          <Item
            name="Name"
            label="Название"
            rules={[
              { required: true, message: 'Введите название бренда' },
              {
                max: 200,
                message: 'Максимальная длина названия 200 символов',
              },
            ]}
          >
            <Input
              type="text"
              placeholder="Введите название"
              disabled={disabledForm}
            />
          </Item>

          <Item
            name="Comment"
            label="Примечание"
            rules={[
              {
                max: 4000,
                message: 'Максимальная длина примечания 4000 символов',
              },
            ]}
          >
            <TextArea
              placeholder="Введите примечание бренда"
              rows={6}
              disabled={disabledForm}
            />
          </Item>

          <div className={`${PF}_buttons`}>
            <Button
              type="primary"
              htmlType="submit"
              className={`${PF}_buttons_item`}
              disabled={disabledForm}
              loading={disabledForm}
            >
              Сохранить
            </Button>
            <Button
              type="default"
              className={`${PF}_buttons_item`}
              onClick={onCancel}
              disabled={disabledForm}
            >
              Отменить
            </Button>
            {mode === 'edit' && IsBrandDelete && (
              <Button
                danger
                className={`${PF}_buttons_item`}
                onClick={openDeleteModal}
                disabled={disabledForm}
              >
                Удалить
              </Button>
            )}
          </div>
        </Form>
      </div>
      <Modal
        title="Удаление бренда"
        open={isDeleteOpen}
        onCancel={closeDeleteModal}
        onOk={onDelete}
        okText="Удалить"
        cancelText="Отмена"
        okButtonProps={{
          danger: true,
          disabled: disabledForm,
          loading: disabledForm,
        }}
        cancelButtonProps={{ disabled: disabledForm }}
      >
        <p>Вы уверены, что хотите удалить этот бренд?</p>
      </Modal>
    </>
  );
};
